import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import { defineComponent, onMounted, ref, onBeforeUpdate, onUnmounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import localCache from '@/utils/localCache';
import { Toast } from 'vant';
import useList from './hooks/useList';
import emitter from '@/eventbus/index';
import MaterialItem from './cpns/MaterialItem.vue';
export default defineComponent({
  name: 'SelectMaterial',
  components: {
    MaterialItem: MaterialItem
  },
  setup: function setup() {
    var route = useRoute();
    if (route.params.warehouse_id) {
      localCache.setItem('warehouse_id', route.params.warehouse_id);
    }
    var params = ref({
      page: 1,
      limit: 10,
      warehouse_id: 0,
      stone_name: ''
    });
    var localCacheWarehouseId = localCache.getItem('warehouse_id');
    if (localCacheWarehouseId) {
      params.value.warehouse_id = localCacheWarehouseId;
    }
    onUnmounted(function () {
      localCache.deleteItem('warehouse_id');
    });
    //设置默认选中的物料
    // if (route.params.defaultCheckedMaterials) {
    //   localCache.setItem(
    //     'defaultCheckedMaterials',
    //     route.params.defaultCheckedMaterials
    //   )
    // }
    // const defaultCheckedMaterials = localCache.getItem(
    //   'defaultCheckedMaterials'
    // )
    // let idArr: string[] = [] //存储默认选中物料的warehouse_id
    // if (defaultCheckedMaterials) {
    //   idArr = (defaultCheckedMaterials as string).split(',')
    // }
    var onSearch = function onSearch(val) {
      //页码重置为1 list清空
      params.value.page = 1;
      list.value.splice(0);
      loading.value = true;
      finished.value = false;
      getWarehouseListAsync();
    };
    var _useList = useList(params),
      _useList2 = _slicedToArray(_useList, 5),
      list = _useList2[0],
      loading = _useList2[1],
      finished = _useList2[2],
      getWarehouseListAsync = _useList2[3],
      onLoad = _useList2[4];
    var checked = ref([]);
    var checkboxRefs = ref([]);
    var toggle = function toggle(index, item) {
      if (!Number(item.stone_stock)) {
        return;
      }
      var a = checkboxRefs.value[index];
      a === null || a === void 0 || a.toggle();
    };
    var router = useRouter();
    var submit = function submit() {
      if (!checked.value.length) {
        Toast('请选择物料!');
        return;
      }
      emitter.emit('select-materials', _toConsumableArray(checked.value));
      router.back();
    };
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getWarehouseListAsync();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    onBeforeUpdate(function () {
      checkboxRefs.value = [];
    });
    // onUnmounted(() => {
    //   localCache.deleteItem('defaultCheckedMaterials')
    //   idArr = []
    // })
    return {
      params: params,
      onSearch: onSearch,
      list: list,
      toggle: toggle,
      checked: checked,
      checkboxRefs: checkboxRefs,
      loading: loading,
      finished: finished,
      onLoad: onLoad,
      submit: submit
    };
  }
});